export default __webpack_public_path__ + "fonts/Jost-v4-latin-600.eot";